import { Component, Input } from '@angular/core';
import { ApartmentType } from '../../../common-theme/models';

@Component({
  selector: 'app-my-apartment-type',
  templateUrl: './my-apartment-type.component.html',
  styleUrls: ['./my-apartment-type.component.scss']
})

export class MyApartmentTypeComponent {
  @Input() apartmentType: ApartmentType;
}



// WEBPACK FOOTER //
// ./src/app/shared/components/my-apartment-type/my-apartment-type.component.ts